import { TbCalendar } from "react-icons/tb";
import { SyncCredentialsTypeEnum } from "types/graphql-schema";

import Button from "@components/button/button";
import { buttonTheme } from "@components/button/button-constants";
import { providerUrl } from "@helpers/constants";

const getCalendarProvider = (currentUser: any) => {
  const credentials = currentUser?.syncCredentials?.edges
    ?.map((edge: any) => edge?.node)
    .find((node: any) =>
      [
        SyncCredentialsTypeEnum.GoogleCalendar,
        SyncCredentialsTypeEnum.OutlookCalendar,
      ].includes(node?.provider),
    );

  return credentials?.provider === SyncCredentialsTypeEnum.OutlookCalendar
    ? SyncCredentialsTypeEnum.OutlookCalendar
    : SyncCredentialsTypeEnum.GoogleCalendar;
};

const CalendarSetupRequired = ({ currentUser }: { currentUser: any }) => {
  const calendarProvider = getCalendarProvider(currentUser);
  const providerName =
    calendarProvider === SyncCredentialsTypeEnum.OutlookCalendar
      ? "Microsoft"
      : "Google";
  const prompt =
    calendarProvider === SyncCredentialsTypeEnum.GoogleCalendar
      ? "&prompt=select_account+consent"
      : "";
  const retryUrl = `/sso/${
    providerUrl[calendarProvider]
  }?request_calendar_scope=true&request_write_scope=true&next=${encodeURIComponent(
    "/onboarding/account-setup",
  )}${prompt}`;

  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-[#fcfcfc] px-6 py-16">
      <div className="flex w-full max-w-[640px] flex-col items-center justify-center gap-8 text-center">
        <div className="flex w-full flex-col items-center gap-2">
          <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-gray-100">
            <TbCalendar className="h-6 w-6 text-gray-900" />
          </div>
          <div className="flex max-w-[560px] flex-col items-center gap-1">
            <h1 className="text-xl font-semibold leading-7 text-gray-900">
              Calendar Setup Required
            </h1>
            <p className="text-sm leading-5 text-gray-600">
              It looks like the calendar integration wasn't allowed when you
              connected your account. Make sure to give {providerName} access to
              your calendar. Please try again.
            </p>
          </div>
        </div>
        <Button theme={buttonTheme.primary} url={retryUrl} text="Try Again" />
      </div>
    </div>
  );
};

export default CalendarSetupRequired;
